import VARIANT from '../textVariant';
/**
 * Helper method to fix rendered html tag: h1, h2, h3, h4
 * could be useful for SEO
 * @param {String} variant
 */
export default function getDefaultAccessibilityProps(variant) {
    switch (variant) {
        case VARIANT.HEADLINE:
            return {
                accessibilityRole: 'heading',
                'aria-level': 1,
            };
        case VARIANT.TITLE_1:
            return {
                accessibilityRole: 'heading',
                'aria-level': 2,
            };
        case VARIANT.TITLE_2:
            return {
                accessibilityRole: 'heading',
                'aria-level': 3,
            };
        case VARIANT.TITLE_3:
            return {
                accessibilityRole: 'heading',
                'aria-level': 4,
            };
        default:
            return {};
    }
}
;
